import styled from "@emotion/styled";
import { useMemo } from "react";

import { Button, PropertiesPanelSection } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { useContextNodeId } from "../../navigation";
import { useSelectedAspect, useSetSelectedNodeId } from "../../selection";
import { useGetById } from "../../state/contextualSelectors";

// TODO: Design decision to not show the Context Triggers, and instead link for now.
// We may want this back soon, so leaving as an example.
//
// export const ContextNodeTriggers = () => {
//   const contextNodeId = useContextNodeId();
//   const getById = useGetById();
//   const contextNode = useMemo(() => getById(contextNodeId), [contextNodeId, getById]);

//   // Do not show Context Triggers for interludes.
//   if (contextNode.role === "interlude") return null;

//   return <TriggersDesigner node={contextNode} />;
// };

const GoToButton = styled(Button)``;

export const ContextNodeTriggers = () => {
  const contextNodeId = useContextNodeId();
  const formatMessage = useFormatMessage(formatStrings);
  const getById = useGetById();
  const contextNode = useMemo(() => (contextNodeId ? getById(contextNodeId) : undefined), [contextNodeId, getById]);
  const setSelectedNodeId = useSetSelectedNodeId();
  const [_, setSelectedAspect] = useSelectedAspect();

  const handleClick = () => {
    setSelectedNodeId(contextNodeId);
    setSelectedAspect("triggers");
  };

  // Do not show Context Triggers for interludes.
  if (!contextNode || contextNode.role === "interlude") return null;

  return (
    <PropertiesPanelSection
      title={
        <>
          <h3>{formatMessage("activityTriggersHeader")}</h3>{" "}
          <GoToButton onClick={handleClick} variant="outlined" size="small">
            {formatMessage("activityTriggersButtonLabel")}
          </GoToButton>
        </>
      }
      empty
    />
  );
};

const formatStrings = {
  activityTriggersHeader: {
    en: "Activity Triggers",
  },
  activityTriggersButtonLabel: {
    en: "Go to Activity",
  },
};
